import { Link, useLocation } from "react-router-dom";

export default function StickyMobileCTA() {
  const location = useLocation();
  if (location.pathname.startsWith("/book") || location.pathname.startsWith("/admin") || location.pathname.startsWith("/confirmation")) return null;

  return (
    <div
      data-testid="sticky-mobile-cta"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0B0B0B]/90 backdrop-blur-xl border-t border-[rgba(184,147,90,0.25)] safe-bottom px-5 py-3"
    >
      <Link
        to="/book"
        data-testid="sticky-book-btn"
        className="btn-primary w-full"
      >
        Book Appointment
      </Link>
    </div>
  );
}
